import { PencilIcon } from "@heroicons/react/outline";
import { useEffect, useState } from "react";
import { getSalesTags, updateSalesTags } from "../../api/salesTag";
import PageLoader from "../../components/pageLoader";
import ToastContainer from "../../components/toastContainer";
import Toast from "../../components/toast";

/* ---------------- COMPONENTS ---------------- */

const SectionCard = ({ title, onEdit, children }) => {
  return (
    <div className="bg-[#131C31] border border-white/10 rounded-lg p-4 relative">
      <div className="flex items-center justify-between mb-5">
        <h3 className="text-white text-sm font-medium">{title}</h3>

        <button onClick={onEdit} className="text-slate-400 hover:text-white">
          <PencilIcon className="w-4 h-4" />
        </button>
      </div>

      <div className="space-y-3">{children}</div>
    </div>
  );
};

const StatusBadge = ({ value }) => (
  <span
    className={`px-2 py-0.5 rounded text-xs font-medium ${
      value ? "bg-green-500/10 text-green-400" : "bg-slate-700 text-slate-300"
    }`}
  >
    {value ? "Enabled" : "Disabled"}
  </span>
);

/* ---------------- SECTIONS ---------------- */

// const ScarcitySection = ({ info }) => {
//   if (!info) return null;

//   return (
//     <SectionCard title="Scarcity Tags">
//       <div className="text-sm text-slate-300">
//         Enabled Scarcity Tags: <StatusBadge value={info.enabled} />
//       </div>

//       <div className="text-sm text-slate-300">
//         Selling fast: <StatusBadge value={info.selling_fast.enabled} />
//       </div>

//       <div className="text-sm text-slate-300">
//         {`Trigger when less than ${info.selling_fast?.threshold}% remaining`}
//       </div>

//       <div className="text-sm text-slate-300">
//         {`Label Text: ${info.selling_fast?.label}`}
//       </div>

//       <div className="text-sm text-slate-300">
//         {`Label Color: ${info.selling_fast?.color}`}
//       </div>

//       <p className="text-xs text-slate-400 flex items-center gap-2 mt-2">
//         <span className="border border-slate-500 rounded-full w-4 h-4 flex items-center justify-center text-xs">
//           i
//         </span>
//         This is a ticket type based tag
//       </p>
//     </SectionCard>
//   );
// };

// const ScarcitySection = ({ info }) => {
//   if (!info) return null;

//   return (
//     <SectionCard title="Scarcity Tags">
//       {/* ENABLED */}
//       <div className="text-sm text-slate-300">
//         Scarcity Tags : <StatusBadge value={info.enabled} />
//       </div>

//       {/* SELLING FAST */}
//       <div className="border-t border-white/10 pt-2 space-y-1">
//         <div className="text-sm text-slate-300 mb-2">
//           Selling Fast: <StatusBadge value={info.selling_fast?.enabled} />
//         </div>

//         {info.selling_fast?.enabled && (
//           <>
//             <p className="text-sm text-white">
//               Trigger when less than{" "}
//               <span className="font-medium">
//                 {info.selling_fast?.threshold}%
//               </span>{" "}
//               remaining
//             </p>

//             <p className="text-sm text-white">
//               Label Text: "{info.selling_fast?.label}"
//             </p>

//             <div className="flex items-center gap-2 text-sm text-white">
//               Label Color:
//               <div
//                 className="w-4 h-4 rounded border border-white/10"
//                 style={{ backgroundColor: info.selling_fast?.color }}
//               />
//               <span className="text-slate-400 text-xs">
//                 {info.selling_fast?.color}
//               </span>
//             </div>
//           </>
//         )}
//       </div>

//       {/* ALMOST SOLD OUT */}
//       <div className="border-t border-white/10 pt-3 space-y-1">
//         <div className="text-sm text-slate-300 mb-2">
//           Almost Sold Out: <StatusBadge value={info.almost_sold_out?.enabled} />
//         </div>

//         {info.almost_sold_out?.enabled && (
//           <>
//             <p className="text-sm text-white">
//               Trigger when less than{" "}
//               <span className="font-medium">
//                 {info.almost_sold_out?.threshold}%
//               </span>
//               remaining
//             </p>

//             <p className="text-sm text-white">
//               Label Text: "{info.almost_sold_out?.label}"
//             </p>

//             <div className="flex items-center gap-2 text-sm text-white">
//               Label Color:
//               <div
//                 className="w-4 h-4 rounded border border-white/10"
//                 style={{ backgroundColor: info.almost_sold_out?.color }}
//               />
//               <span className="text-slate-400 text-xs">
//                 {info.almost_sold_out?.color}
//               </span>
//             </div>
//           </>
//         )}
//       </div>

//       {/* ONLY X LEFT */}
//       <div className="border-t border-white/10 pt-3 space-y-1">
//         <div className="text-sm text-slate-300 mb-3">
//           Only X Left: <StatusBadge value={info.only_x_left?.enabled} />
//         </div>

//         {info.only_x_left?.enabled && (
//           <>
//             <p className="text-sm text-white">
//               Trigger when less than{" "}
//               <span className="font-medium">{info.only_x_left?.threshold}</span>{" "}
//               tickets
//             </p>

//             <p className="text-sm text-white">
//               Label Text: "{info.only_x_left?.label}"
//             </p>

//             <div className="flex items-center gap-2 text-sm text-white">
//               Label Color:
//               <div
//                 className="w-4 h-4 rounded border border-white/10"
//                 style={{ backgroundColor: info.only_x_left?.color }}
//               />
//               <span className="text-slate-400 text-xs">
//                 {info.only_x_left?.color}
//               </span>
//             </div>
//           </>
//         )}
//       </div>

//       {/* INFO */}
//       <p className="text-xs text-slate-400 flex items-center gap-2 mt-2">
//         <span className="border border-slate-500 rounded-full w-4 h-4 flex items-center justify-center text-xs">
//           i
//         </span>
//         This is a ticket type based tag
//       </p>
//     </SectionCard>
//   );
// };

const COLORS = ["#EF4444", "#F59E0B", "#10B981", "#3B82F6", "#8B5CF6"];

const ScarcitySection = ({ info, onSave }) => {
  const [isEditing, setIsEditing] = useState(false);
  const [form, setForm] = useState(info);

  useEffect(() => {
    setForm(info);
  }, [info]);

  if (!info) return null;

  return (
    <SectionCard title="Scarcity Tags" onEdit={() => setIsEditing(true)}>
      {/* ================= VIEW MODE ================= */}
      {!isEditing && (
        <>
          {/* ENABLED */}
          <div className="text-sm text-slate-300">
            Scarcity Tags : <StatusBadge value={info.enabled} />
          </div>

          {/* SELLING FAST */}
          <div className="border-t border-white/10 pt-2 space-y-1">
            <div className="text-sm text-slate-300 mb-2">
              Selling Fast: <StatusBadge value={info.selling_fast?.enabled} />
            </div>

            {info.selling_fast?.enabled && (
              <>
                <p className="text-sm text-white">
                  Trigger when less than{" "}
                  <span className="font-medium">
                    {info.selling_fast?.threshold}%
                  </span>{" "}
                  remaining
                </p>

                <p className="text-sm text-white">
                  Label Text: "{info.selling_fast?.label}"
                </p>

                <div className="flex items-center gap-2 text-sm text-white">
                  Label Color:
                  <div
                    className="w-4 h-4 rounded border border-white/10"
                    style={{ backgroundColor: info.selling_fast?.color }}
                  />
                  <span className="text-slate-400 text-xs">
                    {info.selling_fast?.color}
                  </span>
                </div>
              </>
            )}
          </div>

          {/* ALMOST SOLD OUT */}
          <div className="border-t border-white/10 pt-3 space-y-1">
            <div className="text-sm text-slate-300 mb-2">
              Almost Sold Out:{" "}
              <StatusBadge value={info.almost_sold_out?.enabled} />
            </div>

            {info.almost_sold_out?.enabled && (
              <>
                <p className="text-sm text-white">
                  Trigger when less than{" "}
                  <span className="font-medium">
                    {info.almost_sold_out?.threshold}%
                  </span>
                  remaining
                </p>

                <p className="text-sm text-white">
                  Label Text: "{info.almost_sold_out?.label}"
                </p>

                <div className="flex items-center gap-2 text-sm text-white">
                  Label Color:
                  <div
                    className="w-4 h-4 rounded border border-white/10"
                    style={{
                      backgroundColor: info.almost_sold_out?.color,
                    }}
                  />
                  <span className="text-slate-400 text-xs">
                    {info.almost_sold_out?.color}
                  </span>
                </div>
              </>
            )}
          </div>

          {/* ONLY X LEFT */}
          <div className="border-t border-white/10 pt-3 space-y-1">
            <div className="text-sm text-slate-300 mb-3">
              Only X Left: <StatusBadge value={info.only_x_left?.enabled} />
            </div>

            {info.only_x_left?.enabled && (
              <>
                <p className="text-sm text-white">
                  Trigger when less than{" "}
                  <span className="font-medium">
                    {info.only_x_left?.threshold}
                  </span>{" "}
                  tickets
                </p>

                <p className="text-sm text-white">
                  Label Text: "{info.only_x_left?.label}"
                </p>

                <div className="flex items-center gap-2 text-sm text-white">
                  Label Color:
                  <div
                    className="w-4 h-4 rounded border border-white/10"
                    style={{
                      backgroundColor: info.only_x_left?.color,
                    }}
                  />
                  <span className="text-slate-400 text-xs">
                    {info.only_x_left?.color}
                  </span>
                </div>
              </>
            )}
          </div>

          {/* INFO */}
          <p className="text-xs text-slate-400 flex items-center gap-2 mt-2">
            <span className="border border-slate-500 rounded-full w-4 h-4 flex items-center justify-center text-xs">
              i
            </span>
            This is a ticket type based tag
          </p>
        </>
      )}

      {/* ================= EDIT MODE ================= */}
      {/* ================= EDIT MODE ================= */}
      {isEditing && form && (
        <>
          {/* ENABLE */}
          <label className="flex items-center gap-2 text-sm text-slate-300">
            <input
              type="checkbox"
              checked={form.enabled}
              onChange={(e) => setForm({ ...form, enabled: e.target.checked })}
            />
            Enable Scarcity Tags
          </label>

          {/* SELLING FAST */}
          <div className="border-t border-white/10 pt-3 space-y-2">
            <label className="flex items-center gap-2 text-sm text-slate-300">
              <input
                type="checkbox"
                checked={form.selling_fast?.enabled}
                onChange={(e) =>
                  setForm({
                    ...form,
                    selling_fast: {
                      ...form.selling_fast,
                      enabled: e.target.checked,
                    },
                  })
                }
              />
              Selling Fast
            </label>

            {form.selling_fast?.enabled && (
              <>
                <p className="text-sm text-white flex items-center gap-2 flex-wrap">
                  Trigger when less than
                  <input
                    type="number"
                    value={form.selling_fast?.threshold || ""}
                    onChange={(e) =>
                      setForm({
                        ...form,
                        selling_fast: {
                          ...form.selling_fast,
                          threshold: e.target.value,
                        },
                      })
                    }
                    className="w-16 bg-[#131C31] border border-white/10 rounded px-2 py-1 text-sm text-white"
                  />
                  % remaining
                </p>

                <p className="text-sm text-white flex items-center gap-2 flex-wrap">
                  Label Text:
                  <input
                    value={form.selling_fast?.label || ""}
                    onChange={(e) =>
                      setForm({
                        ...form,
                        selling_fast: {
                          ...form.selling_fast,
                          label: e.target.value,
                        },
                      })
                    }
                    className="bg-[#131C31] border border-white/10 rounded px-2 py-1 text-sm text-white"
                  />
                </p>

                {/* COLORS */}
                <div className="flex gap-2">
                  {COLORS.map((c) => (
                    <button
                      key={c}
                      onClick={() =>
                        setForm({
                          ...form,
                          selling_fast: {
                            ...form.selling_fast,
                            color: c,
                          },
                        })
                      }
                      className={`w-6 h-6 rounded border ${
                        form.selling_fast?.color === c
                          ? "border-white"
                          : "border-white/20"
                      }`}
                      style={{ backgroundColor: c }}
                    />
                  ))}
                </div>
              </>
            )}
          </div>

          {/* ALMOST SOLD OUT */}
          <div className="border-t border-white/10 pt-3 space-y-2">
            <label className="flex items-center gap-2 text-sm text-slate-300">
              <input
                type="checkbox"
                checked={form.almost_sold_out?.enabled}
                onChange={(e) =>
                  setForm({
                    ...form,
                    almost_sold_out: {
                      ...form.almost_sold_out,
                      enabled: e.target.checked,
                    },
                  })
                }
              />
              Almost Sold Out
            </label>

            {form.almost_sold_out?.enabled && (
              <>
                <p className="text-sm text-white flex items-center gap-2 flex-wrap">
                  Trigger when less than
                  <input
                    type="number"
                    value={form.almost_sold_out?.threshold || ""}
                    onChange={(e) =>
                      setForm({
                        ...form,
                        almost_sold_out: {
                          ...form.almost_sold_out,
                          threshold: e.target.value,
                        },
                      })
                    }
                    className="w-16 bg-[#131C31] border border-white/10 rounded px-2 py-1 text-sm text-white"
                  />
                  % remaining
                </p>

                <p className="text-sm text-white flex items-center gap-2 flex-wrap">
                  Label Text:
                  <input
                    value={form.almost_sold_out?.label || ""}
                    onChange={(e) =>
                      setForm({
                        ...form,
                        almost_sold_out: {
                          ...form.almost_sold_out,
                          label: e.target.value,
                        },
                      })
                    }
                    className="bg-[#131C31] border border-white/10 rounded px-2 py-1 text-sm text-white"
                  />
                </p>

                <div className="flex gap-2">
                  {COLORS.map((c) => (
                    <button
                      key={c}
                      onClick={() =>
                        setForm({
                          ...form,
                          almost_sold_out: {
                            ...form.almost_sold_out,
                            color: c,
                          },
                        })
                      }
                      className={`w-6 h-6 rounded border ${
                        form.almost_sold_out?.color === c
                          ? "border-white"
                          : "border-white/20"
                      }`}
                      style={{ backgroundColor: c }}
                    />
                  ))}
                </div>
              </>
            )}
          </div>

          {/* ONLY X LEFT */}
          <div className="border-t border-white/10 pt-3 space-y-2">
            <label className="flex items-center gap-2 text-sm text-slate-300">
              <input
                type="checkbox"
                checked={form.only_x_left?.enabled}
                onChange={(e) =>
                  setForm({
                    ...form,
                    only_x_left: {
                      ...form.only_x_left,
                      enabled: e.target.checked,
                    },
                  })
                }
              />
              Only X Left
            </label>

            {form.only_x_left?.enabled && (
              <>
                <p className="text-sm text-white flex items-center gap-2 flex-wrap">
                  Trigger when less than
                  <input
                    type="number"
                    value={form.only_x_left?.threshold || ""}
                    onChange={(e) =>
                      setForm({
                        ...form,
                        only_x_left: {
                          ...form.only_x_left,
                          threshold: e.target.value,
                        },
                      })
                    }
                    className="w-16 bg-[#131C31] border border-white/10 rounded px-2 py-1 text-sm text-white"
                  />
                  tickets
                </p>

                <p className="text-sm text-white flex items-center gap-2 flex-wrap">
                  Label Text:
                  <input
                    value={form.only_x_left?.label || ""}
                    onChange={(e) =>
                      setForm({
                        ...form,
                        only_x_left: {
                          ...form.only_x_left,
                          label: e.target.value,
                        },
                      })
                    }
                    className="bg-[#131C31] border border-white/10 rounded px-2 py-1 text-sm text-white"
                  />
                </p>

                <div className="flex gap-2">
                  {COLORS.map((c) => (
                    <button
                      key={c}
                      onClick={() =>
                        setForm({
                          ...form,
                          only_x_left: {
                            ...form.only_x_left,
                            color: c,
                          },
                        })
                      }
                      className={`w-6 h-6 rounded border ${
                        form.only_x_left?.color === c
                          ? "border-white"
                          : "border-white/20"
                      }`}
                      style={{ backgroundColor: c }}
                    />
                  ))}
                </div>
              </>
            )}
          </div>

          {/* ACTIONS */}
          <div className="flex justify-end gap-2 mt-4">
            <button
              onClick={() => {
                setForm(info);
                setIsEditing(false);
              }}
              className="px-3 py-1 text-sm text-slate-300 hover:bg-slate-800 rounded"
            >
              Cancel
            </button>

            <button
              onClick={() => {
                onSave?.(form);
                setIsEditing(false);
              }}
              className="px-3 py-1 text-sm bg-pink-600 hover:bg-pink-700 rounded text-white"
            >
              Save
            </button>
          </div>
        </>
      )}
    </SectionCard>
  );
};

// const DemandSection = ({ info }) => {
//   if (!info) return null;

//   return (
//     <SectionCard title="Demand Tags">
//       {/* ENABLED */}
//       <div className="text-sm text-slate-300">
//         Demand Tags: <StatusBadge value={info.enabled} />
//       </div>

//       {/* DEMAND CONFIG */}
//       <div className="border-t border-white/10 pt-3 space-y-1">
//         <p className="text-sm text-white">
//           <span className="font-medium">{info.ticket_count}</span> tickets sold
//           in last <span className="font-medium">{info.hours}</span> hour(s)
//         </p>
//       </div>

//       <p className="text-sm text-white">Label Text: "{info.label}"</p>

//       <div className="flex items-center gap-2 text-sm text-white">
//         Label Color:
//         <div
//           className="w-4 h-4 rounded border border-white/10"
//           style={{ backgroundColor: info.color }}
//         />
//         <span className="text-slate-400 text-xs">{info.color}</span>
//       </div>

//       {/* INFO */}
//       <p className="text-xs text-slate-400 flex items-center gap-2 mt-2">
//         <span className="border border-slate-500 rounded-full w-4 h-4 flex items-center justify-center text-xs">
//           i
//         </span>
//         This is a ticket type based tag
//       </p>
//     </SectionCard>
//   );
// };

const DemandSection = ({ info, onSave }) => {
  const [isEditing, setIsEditing] = useState(false);
  const [form, setForm] = useState(info);

  useEffect(() => {
    setForm(info);
  }, [info]);

  if (!info) return null;

  return (
    <SectionCard title="Demand Tags" onEdit={() => setIsEditing(true)}>
      {/* ================= VIEW MODE ================= */}
      {!isEditing && (
        <>
          <div className="text-sm text-slate-300">
            Demand Tags: <StatusBadge value={info.enabled} />
          </div>

          <div className="border-t border-white/10 pt-3 space-y-1">
            <p className="text-sm text-white">
              <span className="font-medium">{info.ticket_count}</span> tickets
              sold in last <span className="font-medium">{info.hours}</span>{" "}
              hour(s)
            </p>
          </div>

          <p className="text-sm text-white">Label Text: "{info.label}"</p>

          <div className="flex items-center gap-2 text-sm text-white">
            Label Color:
            <div
              className="w-4 h-4 rounded border border-white/10"
              style={{ backgroundColor: info.color }}
            />
            <span className="text-slate-400 text-xs">{info.color}</span>
          </div>

          <p className="text-xs text-slate-400 flex items-center gap-2 mt-2">
            <span className="border border-slate-500 rounded-full w-4 h-4 flex items-center justify-center text-xs">
              i
            </span>
            This is a ticket type based tag
          </p>
        </>
      )}

      {/* ================= EDIT MODE ================= */}
      {isEditing && form && (
        <>
          <label className="flex items-center gap-2 text-sm text-slate-300">
            <input
              type="checkbox"
              checked={form.enabled}
              onChange={(e) => setForm({ ...form, enabled: e.target.checked })}
            />
            Enable Demand Tags
          </label>

          <div className="border-t border-white/10 pt-3 space-y-2">
            <p className="text-sm text-white flex items-center gap-2 flex-wrap">
              <input
                type="number"
                value={form.ticket_count || ""}
                onChange={(e) =>
                  setForm({ ...form, ticket_count: e.target.value })
                }
                className="w-16 bg-[#131C31] border border-white/10 rounded px-2 py-1 text-white"
              />
              tickets sold in last
              <input
                type="number"
                value={form.hours || ""}
                onChange={(e) => setForm({ ...form, hours: e.target.value })}
                className="w-16 bg-[#131C31] border border-white/10 rounded px-2 py-1 text-white"
              />
              hour(s)
            </p>

            <p className="text-sm text-white flex items-center gap-2">
              Label Text:
              <input
                value={form.label || ""}
                onChange={(e) => setForm({ ...form, label: e.target.value })}
                className="bg-[#131C31] border border-white/10 rounded px-2 py-1 text-white"
              />
            </p>

            <div className="flex gap-2">
              {COLORS.map((c) => (
                <button
                  key={c}
                  onClick={() => setForm({ ...form, color: c })}
                  className={`w-6 h-6 rounded border ${
                    form.color === c ? "border-white" : "border-white/20"
                  }`}
                  style={{ backgroundColor: c }}
                />
              ))}
            </div>
          </div>

          {/* ACTIONS */}
          <div className="flex justify-end gap-2 mt-4">
            <button
              onClick={() => {
                setForm(info);
                setIsEditing(false);
              }}
              className="px-3 py-1 text-sm text-slate-300 hover:bg-slate-800 rounded"
            >
              Cancel
            </button>
            <button
              onClick={() => {
                onSave?.(form);
                setIsEditing(false);
              }}
              className="px-3 py-1 text-sm bg-pink-600 rounded text-white"
            >
              Save
            </button>
          </div>
        </>
      )}
    </SectionCard>
  );
};

const SalesMilestoneSection = ({ info, onSave }) => {
  const [isEditing, setIsEditing] = useState(false);
  const [form, setForm] = useState(info);

  useEffect(() => {
    setForm(info);
  }, [info]);

  if (!info) return null;

  return (
    <SectionCard title="Sales Milestones" onEdit={() => setIsEditing(true)}>
      {/* ================= VIEW MODE ================= */}
      {!isEditing && (
        <>
          {/* ENABLED */}
          <div className="text-sm text-slate-300">
            Sales Milestones Tags: <StatusBadge value={info.enabled} />
          </div>

          {/* MILESTONES */}
          <div className="border-t border-white/10 pt-3 space-y-3">
            {info.items?.map((m, index) => (
              <div key={index} className="space-y-1">
                <p className="text-sm text-white">
                  {m.label} → {m.threshold}
                </p>

                <div className="flex items-center gap-2 text-sm text-white">
                  Label Color:
                  <div
                    className="w-4 h-4 rounded border border-white/10"
                    style={{ backgroundColor: m.color }}
                  />
                  <span className="text-slate-400 text-xs">{m.color}</span>
                </div>

                {index !== info.items.length - 1 && (
                  <div className="border-t border-white/10 pt-2" />
                )}
              </div>
            ))}
          </div>

          {/* INFO */}
          <p className="text-xs text-slate-400 flex items-center gap-2 mt-2">
            <span className="border border-slate-500 rounded-full w-4 h-4 flex items-center justify-center text-xs">
              i
            </span>
            This is an event based tag
          </p>
        </>
      )}

      {/* ================= EDIT MODE ================= */}
      {isEditing && form && (
        <>
          {/* ENABLE */}
          <label className="flex items-center gap-2 text-sm text-slate-300">
            <input
              type="checkbox"
              checked={form.enabled}
              onChange={(e) => setForm({ ...form, enabled: e.target.checked })}
            />
            Enable Sales Milestones Tags
          </label>

          {/* MILESTONES */}
          <div className="border-t border-white/10 pt-3 space-y-3">
            {form.items?.map((m, index) => (
              <div key={index} className="space-y-2">
                {/* INLINE SENTENCE */}
                <p className="text-sm text-white flex items-center gap-2 flex-wrap">
                  <input
                    value={m.label}
                    onChange={(e) => {
                      const updated = [...form.items];
                      updated[index].label = e.target.value;
                      setForm({ ...form, items: updated });
                    }}
                    className="bg-[#131C31] border border-white/10 rounded px-2 py-1 text-white"
                  />
                  →
                  <input
                    type="number"
                    value={m.threshold}
                    onChange={(e) => {
                      const updated = [...form.items];
                      updated[index].threshold = e.target.value;
                      setForm({ ...form, items: updated });
                    }}
                    className="w-20 bg-[#131C31] border border-white/10 rounded px-2 py-1 text-white"
                  />
                </p>

                {/* COLOR (same UI preserved) */}
                <div className="flex items-center gap-2 text-sm text-white">
                  Label Color:
                  <div className="flex gap-2">
                    {COLORS.map((c) => (
                      <button
                        key={c}
                        onClick={() => {
                          const updated = [...form.items];
                          updated[index].color = c;
                          setForm({ ...form, items: updated });
                        }}
                        className={`w-5 h-5 rounded border ${
                          m.color === c ? "border-white" : "border-white/20"
                        }`}
                        style={{ backgroundColor: c }}
                      />
                    ))}
                  </div>
                  <span className="text-slate-400 text-xs">{m.color}</span>
                </div>

                {/* SEPARATOR */}
                {index !== form.items.length - 1 && (
                  <div className="border-t border-white/10 pt-2" />
                )}
              </div>
            ))}
          </div>

          {/* INFO */}
          <p className="text-xs text-slate-400 flex items-center gap-2 mt-2">
            <span className="border border-slate-500 rounded-full w-4 h-4 flex items-center justify-center text-xs">
              i
            </span>
            This is an event based tag
          </p>

          {/* ACTIONS */}
          <div className="flex justify-end gap-2 mt-4">
            <button
              onClick={() => {
                setForm(info);
                setIsEditing(false);
              }}
              className="px-3 py-1 text-sm text-slate-300 hover:bg-slate-800 rounded"
            >
              Cancel
            </button>

            <button
              onClick={() => {
                onSave?.(form);
                setIsEditing(false);
              }}
              className="px-3 py-1 text-sm bg-pink-600 hover:bg-pink-700 rounded text-white"
            >
              Save
            </button>
          </div>
        </>
      )}
    </SectionCard>
  );
};

// const SalesMilestoneSection = ({ info }) => {
//   if (!info) return null;

//   return (
//     <SectionCard title="Sales Milestones">
//       {/* ENABLED */}
//       <div className="text-sm text-slate-300">
//         Sales Milestones Tags: <StatusBadge value={info.enabled} />
//       </div>

//       {/* MILESTONES */}
//       <div className="border-t border-white/10 pt-3 space-y-3">
//         {info.items?.map((m, index) => (
//           <div key={index} className="space-y-1">
//             <p className="text-sm text-white">
//               {m.label} → {m.threshold}
//             </p>

//             <div className="flex items-center gap-2 text-sm text-white">
//               Label Color:
//               <div
//                 className="w-4 h-4 rounded border border-white/10"
//                 style={{ backgroundColor: m.color }}
//               />
//               <span className="text-slate-400 text-xs">{m.color}</span>
//             </div>

//             {index !== info.items.length - 1 && (
//               <div className="border-t border-white/10 pt-2" />
//             )}
//           </div>
//         ))}
//       </div>

//       {/* INFO */}
//       <p className="text-xs text-slate-400 flex items-center gap-2 mt-2">
//         <span className="border border-slate-500 rounded-full w-4 h-4 flex items-center justify-center text-xs">
//           i
//         </span>
//         This is an event based tag
//       </p>
//     </SectionCard>
//   );
// };

// const TimeBasedSection = ({ info }) => {
//   if (!info) return null;

//   return (
//     <SectionCard title="Time-Based Tags">
//       {/* ENABLED */}
//       <div className="text-sm text-slate-300">
//         Time-Based Tags: <StatusBadge value={info.enabled} />
//       </div>

//       {/* CONFIG */}
//       <div className="border-t border-white/10 pt-3 space-y-1">
//         <p className="text-sm text-white">
//           Trigger when tier expires in{" "}
//           <span className="font-medium">{info.hours_before}</span>{" "}
//         </p>

//         <p className="text-sm text-white">Label Text: "{info.label}"</p>

//         <div className="flex items-center gap-2 text-sm text-white">
//           Label Color:
//           <div
//             className="w-4 h-4 rounded border border-white/10"
//             style={{ backgroundColor: info.color }}
//           />
//           <span className="text-slate-400 text-xs">{info.color}</span>
//         </div>
//       </div>

//       {/* INFO */}
//       <p className="text-xs text-slate-400 flex items-center gap-2 mt-2">
//         <span className="border border-slate-500 rounded-full w-4 h-4 flex items-center justify-center text-xs">
//           i
//         </span>
//         This is a ticket type based tag
//       </p>
//     </SectionCard>
//   );
// };

const TimeBasedSection = ({ info, onSave }) => {
  const [isEditing, setIsEditing] = useState(false);
  const [form, setForm] = useState(info);

  useEffect(() => setForm(info), [info]);

  if (!info) return null;

  return (
    <SectionCard title="Time-Based Tags" onEdit={() => setIsEditing(true)}>
      {!isEditing ? (
        <>
          <div className="text-sm text-slate-300">
            Time-Based Tags: <StatusBadge value={info.enabled} />
          </div>

          <div className="border-t border-white/10 pt-3 space-y-1">
            <p className="text-sm text-white">
              Trigger when tier expires in{" "}
              <span className="font-medium">{info.hours}</span> hour(s)
            </p>

            <p className="text-sm text-white">Label Text: "{info.label}"</p>

            <div className="flex items-center gap-2 text-sm text-white">
              Label Color:
              <div
                className="w-4 h-4 rounded border border-white/10"
                style={{ backgroundColor: info.color }}
              />
              <span className="text-slate-400 text-xs">{info.color}</span>
            </div>
          </div>
        </>
      ) : (
        <>
          <label className="flex items-center gap-2 text-sm text-slate-300">
            <input
              type="checkbox"
              checked={form.enabled}
              onChange={(e) => setForm({ ...form, enabled: e.target.checked })}
            />
            Enable Time-Based Tags
          </label>

          <div className="border-t border-white/10 pt-3 space-y-2">
            <p className="text-sm text-white flex items-center gap-2">
              Trigger when tier expires in
              <input
                type="number"
                value={form.hours || ""}
                onChange={(e) => setForm({ ...form, hours: e.target.value })}
                className="w-16 bg-[#131C31] border border-white/10 rounded px-2 py-1 text-white"
              />{" "}
              hour(s)
            </p>

            <p className="text-sm text-white flex items-center gap-2">
              Label Text:
              <input
                value={form.label || ""}
                onChange={(e) => setForm({ ...form, label: e.target.value })}
                className="bg-[#131C31] border border-white/10 rounded px-2 py-1 text-white"
              />
            </p>

            <div className="flex gap-2">
              {COLORS.map((c) => (
                <button
                  key={c}
                  onClick={() => setForm({ ...form, color: c })}
                  className={`w-6 h-6 rounded border ${
                    form.color === c ? "border-white" : "border-white/20"
                  }`}
                  style={{ backgroundColor: c }}
                />
              ))}
            </div>
          </div>

          <div className="flex justify-end gap-2 mt-4">
            <button
              onClick={() => {
                setForm(info);
                setIsEditing(false);
              }}
              className="px-3 py-1 text-sm text-slate-300"
            >
              Cancel
            </button>
            <button
              onClick={() => {
                onSave?.(form);
                setIsEditing(false);
              }}
              className="px-3 py-1 text-sm bg-pink-600 text-white"
            >
              Save
            </button>
          </div>
        </>
      )}
    </SectionCard>
  );
};

const FinishCategorySection = ({ info, onSave }) => {
  const [isEditing, setIsEditing] = useState(false);
  const [form, setForm] = useState(info);

  useEffect(() => setForm(info), [info]);

  if (!info) return null;

  return (
    <SectionCard
      title="Finish Category Countdown Tags"
      onEdit={() => setIsEditing(true)}
    >
      {!isEditing ? (
        <>
          <div className="text-sm text-slate-300">
            Finish Category Countdown Tags: <StatusBadge value={info.enabled} />
          </div>

          <div className="border-t border-white/10 pt-3 space-y-1">
            <p className="text-sm text-white">
              Trigger when tier expires in{" "}
              <span className="font-medium">{info.hours}</span> hour(s)
            </p>

            <p className="text-sm text-white">Type: "{info.label}"</p>

            <div className="flex items-center gap-2 text-sm text-white">
              Label Color:
              <div
                className="w-4 h-4 rounded border border-white/10"
                style={{ backgroundColor: info.color }}
              />
              <span className="text-slate-400 text-xs">{info.color}</span>
            </div>
          </div>
        </>
      ) : (
        <>
          <label className="flex items-center gap-2 text-sm text-slate-300">
            <input
              type="checkbox"
              checked={form.enabled}
              onChange={(e) => setForm({ ...form, enabled: e.target.checked })}
            />
            Enable Finish Category Countdown Based Tags
          </label>

          <div className="border-t border-white/10 pt-3 space-y-2">
            <p className="text-sm text-white flex items-center gap-2">
              Trigger when tier expires in
              <input
                type="number"
                value={form.hours || ""}
                onChange={(e) => setForm({ ...form, hours: e.target.value })}
                className="w-16 bg-[#131C31] border border-white/10 rounded px-2 py-1 text-white"
              />{" "}
              hour(s)
            </p>

            <div className="flex items-center gap-2 text-sm text-white">
              Type:
              <select
                value={form.label || ""}
                onChange={(e) => setForm({ ...form, label: e.target.value })}
                className="bg-[#131C31] border border-white/10 rounded px-2 py-1 text-sm text-white focus:outline-none focus:ring-2 focus:ring-pink-500/40 cursor-pointer"
              >
                <option value="">Select type</option>
                <option value="date">Date</option>
                <option value="countdown">Countdown</option>
              </select>
            </div>

            <div className="flex gap-2">
              {COLORS.map((c) => (
                <button
                  key={c}
                  onClick={() => setForm({ ...form, color: c })}
                  className={`w-6 h-6 rounded border ${
                    form.color === c ? "border-white" : "border-white/20"
                  }`}
                  style={{ backgroundColor: c }}
                />
              ))}
            </div>
          </div>

          <div className="flex justify-end gap-2 mt-4">
            <button
              onClick={() => {
                setForm(info);
                setIsEditing(false);
              }}
              className="px-3 py-1 text-sm text-slate-300"
            >
              Cancel
            </button>
            <button
              onClick={() => {
                onSave?.(form);
                setIsEditing(false);
              }}
              className="px-3 py-1 text-sm bg-pink-600 text-white"
            >
              Save
            </button>
          </div>
        </>
      )}
    </SectionCard>
  );
};

/* ---------------- PAGE ---------------- */

const SaleTagsPage = () => {
  const [tags, setTags] = useState(null);
  const [loading, setLoading] = useState(true);
  const [toast, setToast] = useState(null);

  const fetchTags = async () => {
    try {
      setLoading(true);

      const data = await getSalesTags();

      setTags(data);
    } catch (err) {
      setToast({
        type: "error",
        message:
          err?.response?.data?.detail || err?.detail || "Something went wrong",
      });
    } finally {
      setLoading(false);
    }
  };

  const handleTagsUpdate = async (key, value) => {
    try {
      setLoading(true);

      const payload = {
        ...tags,
        [key]: value,
      };

      const updatedData = await updateSalesTags(payload);
      setTags(updatedData);

      setToast({
        type: "success",
        message: "Updated successfully",
      });
    } catch (err) {
      setToast({
        type: "error",
        message: err?.response?.data?.detail || err?.detail || "Update failed",
      });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchTags();
  }, []);

  if (loading) return <PageLoader />;

  return (
    <div className="space-y-6">
      {/* HEADER */}
      <div>
        <h1 className="text-2xl font-semibold text-white">Custom Sales Tags</h1>
        <p className="text-sm text-slate-400">Edit & Manage Tags</p>
      </div>

      {/* GRID */}
      <div className="grid grid-cols-3 gap-4">
        {/* <ScarcitySection info={tags?.scarcity} />
        <DemandSection info={tags?.demand} />
        <SalesMilestoneSection info={tags?.milestones} />
        <TimeBasedSection info={tags?.time_based} /> */}
        <ScarcitySection
          info={tags?.scarcity}
          onSave={(data) => handleTagsUpdate("scarcity", data)}
        />

        <DemandSection
          info={tags?.demand}
          onSave={(data) => handleTagsUpdate("demand", data)}
        />

        <SalesMilestoneSection
          info={tags?.milestones}
          onSave={(data) => handleTagsUpdate("milestones", data)}
        />

        <TimeBasedSection
          info={tags?.time_based}
          onSave={(data) => handleTagsUpdate("time_based", data)}
        />

        <FinishCategorySection
          info={tags?.category_based}
          onSave={(data) => handleTagsUpdate("category_based", data)}
        />
      </div>

      {/* TOAST */}
      <ToastContainer>
        {toast && (
          <div className="toast-enter">
            <Toast
              type={toast.type}
              message={toast.message}
              onClose={() => setToast(null)}
            />
          </div>
        )}
      </ToastContainer>
    </div>
  );
};

export default SaleTagsPage;
